import {type UIContextProps, type UserStateContextProps} from '@colonist/ui'
import {UIUtilsEjsVariables} from './UIUtilsEjsVariables.ts'
import {StorageWrapper} from './StorageWrapper.ts'
import {StringUtils} from '@colonist/utils'
import {ClientUserState} from './ClientUserState.ts'

export const getUIContextValue = (): UIContextProps => ({
    language: UIUtilsEjsVariables.language,
    isUserOnDiscord: UIUtilsEjsVariables.isUserOnDiscord,
    isUserOnMobileAppOrWeb: UIUtilsEjsVariables.isUserOnMobileAppOrWeb,
    isUserOnMobile: UIUtilsEjsVariables.isUserOnMobile,
    isUserOnMobileWebBrowser: UIUtilsEjsVariables.isUserOnMobileWebBrowser,
    isUserOnTabletApp: UIUtilsEjsVariables.isUserOnTabletApp,
    isUserOnDiscordMobile: UIUtilsEjsVariables.isUserOnDiscordMobile,
    discordActivityMobileOrientation: UIUtilsEjsVariables.discordActivityMobileOrientation,
    isPortraitMode: StorageWrapper.isPortraitGamePlayEnabled(),
    versionNumber: UIUtilsEjsVariables.versionNumber,
    discordUrl: UIUtilsEjsVariables.discordChannelUrl,
    playersOnline: StringUtils.parseFormattedNumber(UIUtilsEjsVariables.onlineCount),
    gamesToday: StringUtils.parseFormattedNumber(UIUtilsEjsVariables.gamesToday),
})

export const getUserStateContextValue = (): UserStateContextProps => ({
    userId: ClientUserState.userState?.id,
    isLoggedIn: ClientUserState.userState?.isLoggedIn ?? false,
    totalCompletedGameCount: ClientUserState.userState?.totalCompletedGameCount ?? 0,
    hasMembership: ClientUserState.userState?.items.hasMembership() ?? false,
    hasFoundersPack: ClientUserState.userState?.items.hasFoundersPack() ?? false,
    membershipType: ClientUserState.userState?.items.membership,
})
